/** @jsx jsx */

/** @jsxFrag */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { ButtonGroup, Dialog, TextField, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/program-home';

type AddEmailStepProps = {
  emailField: string;
  onChangeEmail: (event: React.ChangeEvent<HTMLInputElement>) => void;
  getValidationErrors: () => string | false;
  onSubmitEmail: () => void;
  emailFieldError: string;
  loading: boolean;
  onDefer: () => void;
};

const styles = {
  input: css`
    margin-top: var(--cds-spacing-400);
    width: 100%;
  `,
};

const { HeadingGroup, Content, Actions } = Dialog;

const AddEmailStep = ({
  emailField,
  onChangeEmail,
  getValidationErrors,
  onSubmitEmail,
  emailFieldError,
  loading,
  onDefer,
}: AddEmailStepProps) => (
  <>
    <HeadingGroup id="title">{_t('Protect your accomplishments')}</HeadingGroup>
    <Content>
      <Typography2 component="p" id="description">
        {_t('Add a recovery email address to secure your access and safeguard your accomplishments.')}
      </Typography2>
      <TextField
        css={styles.input}
        value={emailField || ''}
        onChange={onChangeEmail}
        onBlur={getValidationErrors}
        label={_t('Recovery email address')}
        name="recovery-email"
        data-testid="recovery-email-input"
        validationStatus={emailFieldError ? 'error' : undefined}
        validationLabel={emailFieldError}
        placeholder={_t('Enter a personal email address (e.g., name@gmail.com)')}
      />
    </Content>
    <Actions>
      <ButtonGroup
        aria-label={_t('Submit or skip email')}
        primaryButtonProps={{
          children: _t('Add a recovery email'),
          onClick: onSubmitEmail,
          loading,
        }}
        alternateButtonProps={{
          children: _t('Cancel'),
          variant: 'secondary',
          onClick: onDefer,
        }}
      />
    </Actions>
  </>
);

export default AddEmailStep;
